import styled from 'styled-components'
import { breakpointMax } from 'utils/style'
import { Col } from '@quotatisgroup/uikit-public.ui.col'

export const StyledBlock = styled.div`
  ${breakpointMax('m')`
    .row div:nth-child(2) {
      order: 3;
    }
  `}
`

export const StyledCol = styled(Col)`
  margin-bottom: 24px;
`
